export enum RouteConfigs {
    FROM_CUSTOMER_DETAILS_ROUTE = "fromCustomerDetailsRoute",
}